import { render, staticRenderFns } from "./PayMoney.vue?vue&type=template&id=5e049443&scoped=true&"
import script from "./PayMoney.vue?vue&type=script&lang=js&"
export * from "./PayMoney.vue?vue&type=script&lang=js&"
import style0 from "./PayMoney.vue?vue&type=style&index=0&id=5e049443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e049443",
  null
  
)

export default component.exports